import LogicSettingsHeader from './LogicSettingsHeader';
import { LogicSettingsHeaderProps, LogicSettingsHeaderValueProps } from './types';

export type { LogicSettingsHeaderProps, LogicSettingsHeaderValueProps };
export default LogicSettingsHeader;
